"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftViewedByNurseSource = void 0;
exports.instanceOfShiftViewedByNurseSource = instanceOfShiftViewedByNurseSource;
exports.ShiftViewedByNurseSourceFromJSON = ShiftViewedByNurseSourceFromJSON;
exports.ShiftViewedByNurseSourceFromJSONTyped = ShiftViewedByNurseSourceFromJSONTyped;
exports.ShiftViewedByNurseSourceToJSON = ShiftViewedByNurseSourceToJSON;
exports.ShiftViewedByNurseSourceToJSONTyped = ShiftViewedByNurseSourceToJSONTyped;
/**
 *
 * @export
 */
exports.ShiftViewedByNurseSource = {
    DetailsPage: 'details_page',
    MyScheduleCalendar: 'my_schedule_calendar'
};
function instanceOfShiftViewedByNurseSource(value) {
    for (const key in exports.ShiftViewedByNurseSource) {
        if (Object.prototype.hasOwnProperty.call(exports.ShiftViewedByNurseSource, key)) {
            if (exports.ShiftViewedByNurseSource[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ShiftViewedByNurseSourceFromJSON(json) {
    return ShiftViewedByNurseSourceFromJSONTyped(json, false);
}
function ShiftViewedByNurseSourceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShiftViewedByNurseSourceToJSON(value) {
    return value;
}
function ShiftViewedByNurseSourceToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=ShiftViewedByNurseSource.js.map